import React, { useState, useEffect } from "react";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import axios from "axios";
import { CHAIN, MORALIS_API_KEY, SERVER_URL } from "../../../Config";
import { QRCodeCanvas } from "qrcode.react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCopy, faXmark } from "@fortawesome/free-solid-svg-icons";
import { ClipLoader } from "react-spinners";

const Deposit = () => {

  const [currentPage, setCurrentPage] = useState(1);
  const [entitiesPerPage, setEntitiesPerPage] = useState(5);
  const [userData, setuserData] = useState([])
  const [selectedAccount, setSelectedAccount] = useState(null);
  const [userWallets, setUserWallets] = useState([]);
  const [UserAccounts, setUserAccounts] = useState([])
  const [tableEntries, setTableEntries] = useState([]);
  const [balances, setBalances] = useState([]);
  const [totalBalance, setTotalBalance] = useState(0);
  const [showLoader, setshowLoader] = useState(false)

  const navigate = useNavigate()

  const getUserdatas = async () => {
    try {
      const token = sessionStorage.getItem('_token');
      if (!token) {
        toast.error('Session Expired');
        navigate('/Login');
        return;
      }

      const decodedToken = jwtDecode(token);
      const res = await axios.get(`${SERVER_URL}/api/getUserdatas?AppID=${decodedToken.AppID}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (res.data.status) {

        setuserData(res.data.User);
        setUserAccounts(res.data.accounts)
        const choosedAccount = sessionStorage.getItem('selectedAccount');

        if (!choosedAccount) {
          setSelectedAccount(res.data.accounts.length > 0 ? res.data.accounts[0].wallet_address : null);
          sessionStorage.setItem('selectedAccount', res.data.accounts.length > 0 ? res.data.accounts[0].wallet_address : null)
        } else {
          setSelectedAccount(sessionStorage.getItem('selectedAccount'))
        }
      } else {
        setuserData([]);
        setSelectedAccount(null);
      }
    } catch (error) {
      console.error('Error fetching user data:', error);

      if (error.response?.status === 403) {
        toast.error('Session expired');
        navigate('/Login');
      } else {
        toast.error('Something went wrong. Please try again.');
      }
    }
  };

  useEffect(() => {
    const token = sessionStorage.getItem('_token');
    if (token) {
      getUserdatas();
    }
  }, [sessionStorage.getItem('_token')]);


  const fetchTransactions = async () => {
    try {
      setshowLoader(true)
      const response = await fetch(
        `https://deep-index.moralis.io/api/v2.2/${selectedAccount}/erc20/transfers?chain=${CHAIN}&order=DESC`,
        {
          method: "GET",
          headers: {
            "accept": "application/json",
            "X-API-Key": MORALIS_API_KEY,
          },
        }
      );

      const data = await response.json();
      if (data.result) {
        const receivedTransactions = data.result
          .filter(tx => tx.to_address.toLowerCase() === selectedAccount.toLowerCase())
          .map(tx => ({
            hash: tx.transaction_hash,
            tokenName: tx.token_symbol,
            time: new Date(tx.block_timestamp).toLocaleDateString("en-GB", {
              day: "2-digit",
              month: "short",
              year: "numeric",
            }).replace(/ /g, " / "),
            amount: (Number(tx.value_decimal)).toFixed(4),
          }));
        setTableEntries(receivedTransactions);
      }
      setshowLoader(false)
    } catch (error) {
      console.error("Error fetching transactions:", error);
      setshowLoader(false)
    }
  };

  const fetchBalances = async () => {
    try {
      setshowLoader(true)
      const response = await fetch(
        `https://deep-index.moralis.io/api/v2.2/${selectedAccount}/erc20?chain=${CHAIN}`,
        {
          method: "GET",
          headers: {
            "accept": "application/json",
            "X-API-Key": MORALIS_API_KEY,
          },
        }
      );

      const data = await response.json();
      if (Array.isArray(data)) {
        let total = 0;

        const formattedBalances = data.map((token) => {
          const balance = token.balance / Math.pow(10, token.decimals);
          total += balance;

          return {
            tokenName: token.name,
            tokenSymbol: token.symbol,
            balance: balance.toFixed(4),
          };
        });

        setBalances(formattedBalances);
        setTotalBalance(total.toFixed(4));
        setshowLoader(false)
      }
    } catch (error) {
      console.error("Error fetching balances:", error);
      setshowLoader(false)
    }
  };

  useEffect(() => {
    if (selectedAccount !== null) {
      fetchTransactions();
      fetchBalances();
    }
  }, [selectedAccount]);

  const indexOfLastEntity = currentPage * entitiesPerPage;
  const indexOfFirstEntity = indexOfLastEntity - entitiesPerPage;
  let currentEntities = tableEntries?.slice(indexOfFirstEntity, indexOfLastEntity);
  const emptyRowCount = entitiesPerPage - currentEntities.length;

  const handlePrevClick = () => {
    setCurrentPage(currentPage - 1);
  };

  const handleNextClick = () => {
    if (currentEntities.length === entitiesPerPage) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handleDropdownChange = (e) => {
    setEntitiesPerPage(parseInt(e.target.value));
    setCurrentPage(1);
  };

  useEffect(() => {
    setSelectedAccount(sessionStorage.getItem('selectedAccount'))
  }, [sessionStorage.getItem('selectedAccount')]);

  const ViewHash = (hash) => {
    window.open(`https://snowtrace.io/tx/${hash}`, "_blank");
  };

  const handleCopy = () => {
    const textToCopy = selectedAccount;
    navigator.clipboard.writeText(textToCopy).then(() => {
      toast.success("Copied to clipboard!");
    }).catch(err => {
      console.error("Failed to copy:", err);
    });
  };

  return (
    <div className="w-full bg-[#060606] relative h-screen overflow-hidden overflow-y-auto text-white font-poppins ">
      <div
        className="z-0 absolute -top-36 left-0 right-0 w-[90%] mx-auto h-96 opacity-30 "
        style={{ background: "radial-gradient(50% 50% at 50% 50%, #FFF2C2 0%, rgba(0, 0, 0, 0) 100%)", }}
      ></div>
      <div className="mt-5 font-inter lg:px-20 px-5">
        <div>
          <p className="font-Artemus text-xl uppercase ">Wallet</p>
          <hr className=" border border-[#856E4F] w-7 " />
        </div>
        <div className="md:w-[90%] mt-12 mx-auto gap-10 flex md:flex-row flex-col items-center ">
          <div className="z-30">
            {selectedAccount && (
              <QRCodeCanvas
                value={selectedAccount} // Wallet address
                size={150} // Adjust size as needed
                bgColor="#000" // Background color
                fgColor="#fff" // Foreground (QR code color)
                className="w-9/12 z-30"
              />
            )}
          </div>
          <div className="md:w-[85%] w-[95%] flex flex-col items-center gap-3 my-5">
            <div className="w-full relative bg-[#D9D9D94A] flex items-center md:gap-10 gap-5 rounded-lg px-5">
              <div className=" absolute -left-9 md:-left-5 md:-top-20 -top-16 ">
                <img src="../assets/other/Balance.svg" className=" scale-80 md:scale-0 " />
              </div>
              <div className="md:w-[30%] md:pl-10 pl-4 ">
                <p className="text-white font-bold ">
                  Balance
                </p>
              </div>
              <div className="w-full pl-3 py-2 border-l border-white/30 flex items-center overflow-hidden overflow-x-auto" >
                <p className="w-full truncate font-Artemus md:text-2xl text-xl ">$ {Number(totalBalance).toFixed(10)}</p>
              </div>
            </div>
            <div className="w-full  bg-[#D9D9D94A] flex md:flex-row flex-col items-center md:divide-x divide-white/30 md:gap-10 rounded-lg px-5 md:py-0 pt-2">
              <div className="md:w-[30%]">
                <p className="text-white w-full font-bold  md:text-left text-center text-nowrap">
                  Wallet address
                </p>
              </div>
              <div className="w-full md:pl-5 py-3 flex justify-between items-center z-20">
                <p className="w-full truncate  md:text-left text-center">{selectedAccount ?? "Connect Wallet"}</p>
                <button
                  disabled={selectedAccount === "null"}
                  className="z-20"
                  onClick={handleCopy}><FontAwesomeIcon icon={faCopy} className='ml-2' /></button>
              </div>
            </div>
          </div>
        </div>
        <div className="bg-[#1D1D1C] rounded-2xl py-5 mt-5 mb-10 w-full mx-auto flex justify-between items-center ">
          <div className="w-[95%] mx-auto">
            <div className=" font-montserrat ">
              <div className="flex justify-center items-center border-b border-white/25 pb-3" >
                <p className="w-[80%] sm:text-lg text-base font-semibold">Deposit History</p>
                <p className="text-end text-xs px-3">
                  Show no of entity
                  <select
                    className="ml-2 outline-none rounded-md bg-transparent border-[1px]"
                    onChange={handleDropdownChange}
                    value={entitiesPerPage}
                  >
                    <option className="text-black" value="4">
                      5
                    </option>
                    <option className="text-black" value="5">
                      10
                    </option>
                    <option className="text-black" value="10">
                      20
                    </option>
                  </select>
                </p>
              </div>
              <div className="pb-5  overflow-hidden">
                <div className="overflow-x-auto">
                  <table className="w-full text-center">
                    <thead>
                      <tr className=" text-[#E5E5E5] text-sm">
                        <th className="py-5 px-5 md:px-0 whitespace-nowrap">
                          Trasaction Hash
                        </th>
                        <th className="py-5 px-5 md:px-0 whitespace-nowrap">
                          Quantity
                        </th>
                        <th className="py-5 px-5 md:px-0 whitespace-nowrap">
                          Tokens
                        </th>
                        <th className="py-5 px-5 md:px-0 whitespace-nowrap">
                          Date of transaction
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {currentEntities.map((entity, index) => (
                        <tr key={index} className={`h-14 w-full text-xs md:text-sm cursor-pointer rounded-xl ${index % 2 === 0 ? "bg-[#856E4F0F]" : "bg-transparent"}`}>
                          <td className="px-5 lg:px-0 whitespace-nowrap" onClick={() => ViewHash(entity.hash)}>
                            {entity.hash}</td>
                          <td className="text-green-600 font-medium px-5 lg:px-0 whitespace-nowrap">
                            {entity.amount}</td>
                          <td className="px-5 lg:px-0 whitespace-nowrap uppercase">
                            {entity.tokenName}</td>
                          <td className="px-5 lg:px-0 whitespace-nowrap">
                            {entity.time}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="mt-2 flex justify-end text-xs px-10">
                <div className="flex gap-3">
                  <button
                    className={`bg-white/20  rounded-md px-2 py-1  `}
                    onClick={handlePrevClick}
                    disabled={currentPage === 1}
                  >
                    <i class="fa-solid fa-arrow-left"></i>
                  </button>
                  <button
                    className={` bg-white/20 rounded-md px-2 py-1  `}
                    onClick={handleNextClick}
                    disabled={currentEntities.length < entitiesPerPage}
                  >
                    <i class="fa-solid fa-arrow-right"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        {showLoader && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              background: "rgba(0, 0, 0, 0.5)", // Semi-transparent background
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 9999, // Ensures overlay appears on top
              backdropFilter: "blur(5px)", // Apply blur effect to background
            }}
          >
            <div className="flex flex-col gap-4 justify-center items-center">
              <ClipLoader color="#ffffff" size={50} />
              <p style={{ color: "#ffffff", fontSize: "18px" }} className="text-center">
                Loading...
              </p>
            </div>

          </div>
        )}
      </div>
    </div>
  );
};

export default Deposit;
